import { api } from '@/lib/axios'

async function deleteOrderAlert(orderId: string) {
  await api.delete(`/orders/${orderId}/alerts`)
}

export { deleteOrderAlert }
